import { k as A, l as S, n as F, o as m, p as w, q as C, r as I, s as R, t as d, u as x } from "./lodash.CbaCmyiN.js";
var D = F, E = m, H = w, L = A, M = S, P = C, U = 200;
function W(a, n, r, f) {
  var s = -1, h = E, _ = !0, i = a.length, b = [], o = n.length;
  if (!i)
    return b;
  r && (n = L(n, M(r))), f ? (h = H, _ = !1) : n.length >= U && (h = P, _ = !1, n = new D(n));
  n:
    for (; ++s < i; ) {
      var e = a[s], t = r == null ? e : r(e);
      if (e = f || e !== 0 ? e : 0, _ && t === t) {
        for (var l = o; l--; )
          if (n[l] === t)
            continue n;
        b.push(e);
      } else
        h(n, t, f) || b.push(e);
    }
  return b;
}
var z = W, y = I, $ = d, k = R, g = y ? y.isConcatSpreadable : void 0;
function q(a) {
  return k(a) || $(a) || !!(g && a && a[g]);
}
var G = q, Y = x, Z = G;
function c(a, n, r, f, s) {
  var h = -1, _ = a.length;
  for (r || (r = Z), s || (s = []); ++h < _; ) {
    var i = a[h];
    n > 0 && r(i) ? n > 1 ? c(i, n - 1, r, f, s) : Y(s, i) : f || (s[s.length] = i);
  }
  return s;
}
var B = c;
export {
  z as _,
  B as a
};
//# sourceMappingURL=_baseFlatten.CTP4NVXz.js.map
